import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-62073ace")

_pushScopeId("data-v-62073ace")
const _hoisted_1 = { class: "jump-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
    title: _ctx.$wordList.Notice,
    width: "400px",
    footerType: "customize"
  }, {
    footer: _withId(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("p", {
          class: "jump break-word",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.jump && _ctx.jump(...args)))
        }, _toDisplayString(_ctx.$wordList.JumpPage), 1)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})